import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await client.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/app");
        navigate("/app", { replace: true, state: { user: res.data } });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/", { replace: true }), 2500);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-sand text-olive" data-testid="auth-callback">
      <div className="animate-pulse-soft rounded-full bg-sage p-5 mb-6">
        <Leaf className="w-8 h-8 text-sky" />
      </div>
      <p className="font-serif text-2xl">
        {error ? "Something went wrong. Redirecting…" : "Welcoming you in…"}
      </p>
    </div>
  );
}
